import React, { Component } from 'react';
import { Grid, TextField } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import CountrySelect from '../ui/CountrySelect'
import RegionSelect from '../ui/RegionSelect'

const styleSheet = theme => ({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    select: {
      marginLeft: -8,
      marginTop: -8,
    },
});
  
class Address extends Component {
  /*
    Required props are:
      address object with attributes:
        country
        state
        address1
        address2
        city
        postalCode

      regionLabel
      setCountryCodeState
      setRegionCodeState
      setAddress1State
      setAddress2State
      setCityState
      setPostalCodeState
  */
  
    setCountryCodeState = (aValue) => {
      this.props.setCountryCodeState(aValue);
    };
  
    setRegionCodeState = (aValue) => {
      this.props.setRegionCodeState(aValue);
    };
    
    setAddress1State = (aValue) => {
      this.props.setAddress1State(aValue);
    };

    setAddress2State = (aValue) => {
      this.props.setAddress2State(aValue);
    };
          
    setCityState = (aValue) => {
      this.props.setCityState(aValue);
    };
  
    setPostalCodeState = (aValue) => {
      this.props.setPostalCodeState(aValue);
    };
            
    render() {
      const classes = this.props.classes;

      return (
        <Grid container spacing={2} justifyContent="space-around">
          <Grid item xs={12} sm={6}>
            <div className={classes.select}>
              <CountrySelect
                showRequired={this.props.showRequired}
                displayOnly={this.props.displayOnly}
                countryCode={this.props.address.country}
                setCountryCodeState={this.setCountryCodeState}
                widthOverride='98%'
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            <div className={classes.select}>
              <RegionSelect
                showRequired={this.props.showRequired}
                displayOnly={this.props.displayOnly}
                countryCode={this.props.address.country}
                regionCode={this.props.address.state}
                setRegionCodeState={this.setRegionCodeState}
                widthOverride='98%'
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={6}>
            {!this.props.displayOnly &&
              <TextField  data-recording-ignore="mask"
                id="address1" label={this.props.showRequired ? 'Address 1 *' : 'Address 1'} 
                value={this.props.address.address1}
                onChange={ (e) => this.setAddress1State(e.target.value) }
                inputProps={{ maxLength: 64 }}
              />
            }
            {this.props.displayOnly &&
              <TextField  data-recording-ignore="mask"
                id="address1" label={this.props.showRequired ? 'Address 1 *' : 'Address 1'} 
                value={this.props.address.address1}
                InputProps={{ readOnly: true, disableUnderline: true }}                 
              />
            }

          </Grid>
          <Grid item xs={12} sm={6}>
            {!this.props.displayOnly &&
              <TextField  data-recording-ignore="mask"
                id="address2" label="Address 2" 
                value={(this.props.address.address2 === null) ? '' : this.props.address.address2}
                onChange={ (e) => this.setAddress2State(e.target.value) }
                inputProps={{ maxLength: 64 }}
              />
            }
            {this.props.displayOnly &&
              <TextField  data-recording-ignore="mask"
                id="address2" label={"Address 2"} 
                value={(this.props.address.address2 === '') ? ' ' : this.props.address.address2}
                InputProps={{ readOnly: true, disableUnderline: true }}                 
              />
            }
          </Grid>
          <Grid item xs={12} sm={6}>
            {!this.props.displayOnly &&
              <TextField  data-recording-ignore="mask"
                id="city" label={this.props.showRequired ? 'City *' : 'City'} 
                value={this.props.address.city}
                onChange={ (e) => this.setCityState(e.target.value) }
                inputProps={{ maxLength: 64 }}
              />
            }
            {this.props.displayOnly &&
              <TextField  data-recording-ignore="mask"
                id="city" label={this.props.showRequired ? 'City *' : 'City'} 
                value={this.props.address.city}
                InputProps={{ readOnly: true, disableUnderline: true }}                 
              />
            }
          </Grid>
          <Grid item xs={12} sm={6}>
            {!this.props.displayOnly &&
              <TextField  data-recording-ignore="mask"
                id="postal-code" label={this.props.showRequired ? 'Postal code *' : 'Postal code'} 
                value={this.props.address.postalCode}
                onChange={ (e) => this.setPostalCodeState(e.target.value) }
                inputProps={{ maxLength: 10 }}
              />
            }
            {this.props.displayOnly &&
              <TextField  data-recording-ignore="mask"
                id="postal-code" label={this.props.showRequired ? 'Postal code *' : 'Postal code'} 
                value={this.props.address.postalCode}
                InputProps={{ readOnly: true, disableUnderline: true }}                 
              />
            }
          </Grid>
        </Grid>        
      );
    }     
  }
  
  export default withStyles(styleSheet)(Address);
  
